import React, { useState, useContext } from "react";
import { Grid, TextField, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthProvider";
import AuthLayout from "../../components/AuthLayout";
import bgImage from "../../images/main-bg.jpg";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { useLang } from "../../context/LangContext";
const arabicMessages = {
  required: "الحقل مطلوب",
  email: "يرجى إدخال بريد إلكتروني صالح",
  phone: "يرجى إدخال رقم هاتف صالح",
  numeric: "يجب أن يكون الحقل رقمًا",
  password: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  otp: "يرجى إدخال رمز التحقق",
};

const SignUpPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { signUp, signUpWithPhone, verifyPhoneRegister } = useContext(AuthContext);
  const [signUpMethod, setSignUpMethod] = useState("phone"); // "email" or "phone"
    const [otpSent, setOtpSent] = useState(false);
    const { lang } = useLang();
  const navigate = useNavigate(); 
  
  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
      messages: lang === "ar" ? arabicMessages : undefined,
    })
  );


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
    otp: "",
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const validatePassword = (password) => /^(?=.*\d).{8,}$/.test(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (signUpMethod === "email") {

    const { password, confirm_password } = formData;

    if (!validatePassword(password)) {
      toast.error(t(`passwordValidation`));
      return;
    }

    if (password !== confirm_password) {
      toast.error(t(`passwordMatchError`));
      return;
    }

    if (validator.allValid()) {
      try {
        setLoading(true);
        await signUp(formData);
        toast.success(t(`signupSuccess`));
        navigate("/login");
      } catch (error) {
        toast.error(error.message);
      }
      setLoading(false);
    } else {
      validator.showMessages();
      toast.error(t(`fillRequiredFields`));
    }
  }
  else {
    try {
      setLoading(true);
      const response = await signUpWithPhone(formData.phone, formData.name, formData.email);
      if (response.success) {
        toast.success(t(`OTPSent`));
        setOtpSent(true);
        return;
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  };

  const handleVerifyOtp = async () => {
    if (!formData.phone) {
      toast.error(t(`PhoneRequired`));
      return;
    }
    try {
      setLoading(true);
      await verifyPhoneRegister(formData.phone, formData.otp);
      toast.success(t(`LoginSuccessful`));
      navigate("/");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthLayout image={bgImage}>
    <Grid className="loginWrapper" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Grid className="loginForm">
        <h2>{t(`register`)}</h2>
        <p>{t(`registerText`)}</p>
                <div className="loginToggle">
                  <Button
                    onClick={() => setSignUpMethod("email")}
                    disabled={signUpMethod === "email"}
                  >
                    {t(`emailAndPassword`)}
                  </Button>
                  <Button
                    onClick={() => setSignUpMethod("phone")}
                    disabled={signUpMethod === "phone"}
                  >
                    {t(`phone`)}
                  </Button>
                </div>
        
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {!otpSent && ["name", "email", "phone"].map(
              (field) => (
                <Grid item xs={12} key={field}>
                  <TextField
                    className="inputOutline"
                    fullWidth
                    variant="outlined"
                    name={field}
                    label={t(`${field}`)}
                    type={field.includes("password") ? "password" : "text"}
                    value={formData[field]}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    dir={field === "phone" ? "ltr" : "auto"}
                  />
              {signUpMethod === "phone" && field === "phone" &&
                    validator.message("phone", field, "required|phone")}
              {signUpMethod === "email" && field === "email" &&
                    validator.message("email", field, "required|email")}
                </Grid>
              ),
            )}
            {signUpMethod === "email" ?
              ["password", "confirm_password"].map(
              (field) => (
                <Grid item xs={12} key={field}>
                  <TextField
                    className="inputOutline"
                    fullWidth
                    variant="outlined"
                    name={field}
                    label={t(`${field}`)}
                    
                    type={field.includes("password") ? "password" : "text"}
                    value={formData[field]}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                  
                    {field === "password" &&    
                      validator.message("password", formData[field], "required|password")}
                </Grid>
              ),
            ): signUpMethod === "phone" && otpSent && (        
             <>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t(`otp`)}
                  name="otp"
                  value={formData.otp}
                  onChange={handleChange}
                    variant="outlined"
                    dir="ltr"
                />
                      {validator.message("otp", formData.otp, "required|otp")}
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  onClick={handleVerifyOtp}
                  disabled={loading}
                >
                  {t(`verifyOtp`)}
                </Button>
              </Grid>
            </>
            )}
            {!otpSent && (

            <Grid item xs={12}>
              <Button
                fullWidth
                className="cBtn cBtnLarge cBtnTheme"
                type="submit"
                disabled={loading}
              >
                {loading ? t(`loading`) : t(`register`)}
              </Button>
            </Grid>
            )}
          </Grid>
        </form>
        <p className="noteHelp">
          {t(`alreadyHaveAccount`)}{" "}
          <Link to="/login">{t(`login`)}</Link>
        </p>
      </Grid>
    </Grid>
  </AuthLayout>
  );
};

export default SignUpPage;
